import { Icon } from '@smartgift/frontend-toolkit';
import { useTranslation } from 'react-i18next';

import { useNotification } from '@hero/store/hooks';
import { remindFormData, remindFormValidationSchema } from '@hero/validations/schemas';

export function useSendRemindersNotification({ useSendReminder } = {}) {
  const { t } = useTranslation();
  const { showNotification, showSuccess } = useNotification();
  const { mutate } = useSendReminder({
    onSuccess: () => {
      showSuccess({
        message: t('sendReminderSuccessText'),
        type: 'toast'
      });
    }
  });

  const isAutomation = window?.location.pathname.includes('automation');

  const send = (code, orderCodes) => {
    showNotification({
      header: t('sendReminderQuestionHeader'),
      message: isAutomation ? t('sendReminderMessageAutomation') : t('sendReminderMessage'),
      formData: remindFormData,
      formValidationSchema: remindFormValidationSchema,
      notificationImage: <Icon name="email" size="xxl" />,
      secondaryButtonProps: { children: t('cancel') },
      primaryButtonProps: { children: t('send') },
      onSubmit: values => {
        mutate({ code, orderCodes, subject: values?.formValues?.subject });
      }
    });
  };

  return { send };
}
